import {
  emailRegex,
  mobileNumWithOptional91AndPlus91Regex,
  mobileNumWithOptional91Regex,
  panNumRegex,
} from 'Constants'
import {
  addressWithoutRepeatedSpecialCharsRegex,
  alphabetWithNumberRegex,
  nameWithDotAndSpaceRegex,
  onlyAlphabetsWithSpaceRegex,
  panWithForm60Regex,
} from 'Constants/regex'
import { INestedQuestionSet } from 'Models/BOB/ResponseModels/Life/QuestionSet'

const personDisabilityRenderObject: {
  form_fields: INestedQuestionSet[]
} = {
  form_fields: [
    {
      max: 10,
      name: 'Mobile Number of Authorised Representative',
      code: 'mobileNumberOfAuthorisedRepresentative',
      dropdown: {},
      cover_type: 'Text',
      min: 10,
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      required: true,
      regex: mobileNumWithOptional91AndPlus91Regex,
    },
    {
      max: undefined,
      name: 'Email of Authorised Representative',
      code: 'emailOfAuthorisedRepresentative',
      dropdown: {},
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      required: true,
      regex: emailRegex,
    },
    {
      name: 'Name of Authorised Representative',
      code: 'nameOfAuthorisedRepresentative',
      cover_type: 'Text',
      input_type: 'text',
      hidden: false,
      dropdown: {},
      values: {},
      min: 2,
      max: 30,
      required: true,
      regex: nameWithDotAndSpaceRegex,
      description: '',
    },
    {
      name: 'Father/Mother Name of Representative Person',
      code: 'fatherMotherNameOfAuthorisedRepresentative',
      dropdown: {},
      cover_type: 'Text',
      min: 2,
      max: 30,
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      required: true,
      regex: nameWithDotAndSpaceRegex,
    },
    {
      name: 'Authorised person’s residence',
      code: 'authorisePersonResidence',
      dropdown: {},
      cover_type: 'Text',
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      required: true,
      regex: addressWithoutRepeatedSpecialCharsRegex,
    },
    {
      max: undefined,
      name: 'Name of Proposer',
      code: 'nameOfProposer',
      dropdown: {},
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'Text',
      hidden: false,
      is_disabled: true,
      values: {},
      required: true,
      regex: onlyAlphabetsWithSpaceRegex,
    },
    {
      max: undefined,
      name: 'Confirmed at (Location)',
      code: 'confirmedLocation',
      dropdown: {},
      cover_type: 'Text',
      min: undefined,
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      required: true,
      regex: onlyAlphabetsWithSpaceRegex,
    },
    {
      name: 'Signature of the Authorised Representative',
      code: 'signatureOfAuthorisedRepresentative',
      dropdown: {},
      cover_type: 'Text',
      required: true,
      min: undefined,
      description: '',
      input_type: 'Text',
      hidden: false,
      values: {},
      regex: onlyAlphabetsWithSpaceRegex,
    },
    {
      name: 'Relationship of Authorised Representative',
      code: 'relationshipOfAuthorisedRepresentative',
      required: true,
      dropdown: {
        Father: 'Father',
        Brother: 'Brother',
        Sister: 'Sister',
        Mother: 'Mother',
        Cousin: 'Cousin',
        Daughter: 'Daughter',
        'Grand Father': 'Grand Father',
        'Grand Mother': 'Grand Mother',
        Husband: 'Husband',
        Son: 'Son',
        Trustee: 'Trustee',
        Wife: 'Wife',
        Others: 'Others',
        Grandson: 'Grandson',
        Granddaughter: 'Granddaughter',
      },
      cover_type: 'dropdown',
      min: undefined,
      description: '',
      input_type: 'single-select',
      hidden: false,
      values: {},
      regex: undefined,
    },
  ],
}

export default personDisabilityRenderObject
